"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var spaui_utils_1 = require("@tencent/spaui-utils");

var odc_frame_1 = __importDefault(require("@tencent/odc-frame"));

var info_1 = __importDefault(require("./info"));

var spaui_1 = require("@tencent/spaui");

var DefaultImgComponent_1 = __importDefault(require("./DefaultImgComponent"));

function Figure(props, ref) {
  var _a;

  var src = props.src,
      _b = props.alt,
      alt = _b === void 0 ? '' : _b,
      _c = props.clear,
      clear = _c === void 0 ? false : _c,
      _d = props.backdrop,
      backdrop = _d === void 0 ? true : _d,
      children = props.children,
      w = props.w,
      h = props.h,
      checkable = props.checkable,
      checked = props.checked,
      onClear = props.onClear,
      clearProps = props.clearProps,
      checkProps = props.checkProps,
      _e = props.radius,
      radius = _e === void 0 ? '6' : _e,
      loading = props.loading,
      _f = props.objectFit,
      objectFit = _f === void 0 ? 'contain' : _f,
      imgNode = props.imgNode,
      _g = props.ImgComponent,
      ImgComponent = _g === void 0 ? DefaultImgComponent_1["default"] : _g,
      // eslint-disable-line
  options = props.options,
      imgId = props.imgId,
      restProps = __rest(props, ["src", "alt", "clear", "backdrop", "children", "w", "h", "checkable", "checked", "onClear", "clearProps", "checkProps", "radius", "loading", "objectFit", "imgNode", "ImgComponent", "options", "imgId"]);

  return react_1["default"].createElement(odc_frame_1["default"], __assign({}, restProps, (0, spaui_utils_1.globalProps)(props, {
    className: (0, classnames_1["default"])('odc-figure', (_a = {}, _a['has-clear'] = clear, _a['has-backdrop'] = backdrop, _a['has-children'] = children, _a['has-check'] = checkable, _a['no-src'] = !src, _a.checked = checked, _a)),
    supportAllEvents: true,
    ref: ref
  }, Figure), {
    w: w,
    h: h,
    radius: radius,
    useClassName: false
  }), react_1["default"].createElement("div", {
    className: "odc-figure-inner"
  }, react_1["default"].createElement(ImgComponent, {
    objectFit: objectFit,
    src: src,
    alt: alt,
    loading: loading,
    options: options,
    imgId: imgId
  }), imgNode), children, clear ? react_1["default"].createElement("i", __assign({
    className: "odc-figure-clear",
    onClick: onClear
  }, clearProps), react_1["default"].createElement(spaui_1.Icon, {
    className: "odc-figure-clear-svg",
    name: "close-filled"
  })) : null, checkable ? react_1["default"].createElement("i", __assign({
    className: "odc-figure-check"
  }, checkProps), react_1["default"].createElement(spaui_1.Icon, {
    name: "check-filled",
    className: "odc-figure-check-svg"
  })) : null);
}

(0, spaui_utils_1.setComponentMark)(Figure, info_1["default"]);
exports["default"] = react_1["default"].memo(react_1["default"].forwardRef(Figure));